(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dishful-featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dishful-gallery')) {
    customElements.define(
      'dishful-gallery',
      class DishfulGallery extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.thumbs = [...this.querySelectorAll('[data-thumb]')];
          this.index = 0;
          this.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => this.select(Number(thumb.dataset.thumb)));
            thumb.addEventListener('keydown', (event) => this.#onKeydown(event));
          });

          // Swipe between images on touch screens
          const stage = this.querySelector('.dishful-product__stage');
          let startX = null;
          stage?.addEventListener('pointerdown', (event) => {
            if (event.pointerType !== 'mouse') startX = event.clientX;
          });
          stage?.addEventListener('pointerup', (event) => {
            if (startX === null) return;
            const deltaX = event.clientX - startX;
            startX = null;
            if (Math.abs(deltaX) > 40) this.select(this.index + (deltaX < 0 ? 1 : -1));
          });
          stage?.addEventListener('pointercancel', () => (startX = null));
        }

        #onKeydown(event) {
          const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
          if (!step) return;
          event.preventDefault();
          this.select(this.index + step);
          this.thumbs[this.index]?.focus();
        }

        select(index) {
          const count = this.slides.length;
          if (!count) return;
          index = (index + count) % count;
          this.index = index;
          this.slides.forEach((slide, i) => {
            const active = i === index;
            slide.classList.toggle('is-active', active);
            slide.toggleAttribute('aria-hidden', !active);
          });
          this.thumbs.forEach((thumb, i) => {
            if (i === index) {
              thumb.setAttribute('aria-current', 'true');
            } else {
              thumb.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
